module.exports = __webpack_public_path__ + "static/media/aa_chamber_of_commerce.74a61a35.jpg";